import React from 'react'
import styled from 'styled-components'
import { Button } from '../../../Common'

export const BasicConsent = ({
  url,
  agree,
  configure,
  description,
  label,
  setAdvanced,
  onSave,
}: BasicConsentProps) => {
  return (
    <>
      <Content>{description}</Content>
      <span className="d-flex flex-column flex-lg-row">
        <Button
          fullWidth
          bordered
          className="mt-5 mx-lg-1"
          onClick={setAdvanced}
        >
          <span>{configure}</span>
        </Button>
        <Button
          fullWidth
          variant="green"
          className=" mt-2 mt-lg-5 mx-lg-1"
          onClick={onSave}
        >
          <span>{agree}</span>
        </Button>
      </span>
    </>
  )
}

export type BasicConsentProps = {
  label: string
  configure: string
  url: string
  description: string
  agree: string
  setAdvanced: () => void
  onSave: () => void
}

const Content = styled.div`
  width: 100%;
  font-size: 1.2rem;
  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    font-size: 16px;
  }
`

const Anchor = styled.a`
  text-decoration: underline;
  &:hover {
    cursor: pointer;
  }
`
